// This above lines import basic polyfills
import 'core-js/stable';
import 'regenerator-runtime/runtime';

import {getUserProfile} from 'Components/clientStatus/clientStatus';
import {ParseUrlParamController} from "./components/ParseUrlParamController";
import {register as registerBehaviorScroll} from './behaviors/BehaviorScroll';
import {register as behaviorClickRegistered} from 'Utils/behaviorClick';

import lightModule from './lightModule';
import './loadIECSS.js';
import focusWithinPolyfill from './polyfills/focusWithinPolyfill';

require('domready')(function () {
    // Set isConnectedClient global variable to use it in all personalized components

    getUserProfile();
    lightModule.init();
    new ParseUrlParamController();
    registerBehaviorScroll();
    behaviorClickRegistered();
    focusWithinPolyfill();
});
